module.exports = __webpack_public_path__ + "img/pdf-report.7a5a927f.png";